// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CategoryTitle_titleContainer__WwSVw","title":"CategoryTitle_title__ceabd","subTitle":"CategoryTitle_subTitle__qvJRj"};